<form class="mb-2" #rubriqueForm="ngForm">

	<div class="p-fluid grid formgrid p-2">

		<div class="field-checkbox col-12">
			<p-checkbox
				name="rub_actif"
				inputId="rub_actif"
				[(ngModel)]="rubrique.rub_actif"
				[binary]="true"
				inputId="binary"
				[label]="'rubriques.active_state' | translate"
				[disabled]="!editMode"
			></p-checkbox>
		</div>

		<!-- Nom -->
		<div class="field col-12">
			<label for="rub_nom">
				{{ 'common.name_label' | translate }}
			</label>
			<input
				type="text"
				pInputText
				name="rub_nom"
				[(ngModel)]="rubrique.rub_nom"
				[attr.placeholder]="'common.name_label' | translate"
				[readOnly]="!editMode"
				[required]="true"
			/>
		</div>

		<div class="col-12"></div>

		<!-- Famille -->
		<div class="field col-6">
			<label for="thm_nom">
				{{ 'families.family_label' | translate }}
			</label>
			<famille-selector
				name="fam_id"
				[(ngModel)]="rubrique.fam_id"
				(ngModelChange)="onFamilleChange()"
				[readonly]="!editMode"
			>
			</famille-selector>
		</div>


		<!-- Thème -->
		<div class="field col-6">
			<label for="thm_nom">
				{{ 'themes.theme_label' | translate }}
			</label>
			<theme-selector
				name="thm_id"
				[fam_id]="rubrique.fam_id"
				[(ngModel)]="rubrique.thm_id"
				[readonly]="!editMode"
				[required]="true"
			>
			</theme-selector>
		</div>

		<!-- Privatisation -->
		<div class="field col-6">
			<label for="thm_nom">
				{{ 'rubriques.privatization_label' | translate }}
			</label>

			<!-- Vue admin -->
			<abonne-selector
				*ngIf="me.uti_administrateur"
				name="abo_id_privatisation"
				[(ngModel)]="rubrique.abo_id_privatisation"
				[readonly]="!editMode || !isCreation"
				[nullOption]="editMode && isCreation"
				[placeholder]="'rubriques.not_privatized' | translate"
			>
			</abonne-selector>

			<!-- Vue pour les utilisateurs non-admin -->
			<input
				*ngIf="!me.uti_administrateur && currentAbonne"
				type="text"
				pInputText
				[attr.value]="
					((rubrique.abo_id_privatisation == currentAbonne.abo_id) ? 'common.yes' : 'common.no') | translate
				"
				[readonly]="true"
			>
		</div>

		<!-- Description -->

		<div class="field col-12">
			<label for="rub_description">
				{{ 'common.description_label' | translate }}
			</label>
			<textarea
				pInputTextarea
				name="rub_description"
				[(ngModel)]="rubrique.rub_description"
				[autoResize]="true"
				[readOnly]="!editMode"
			></textarea>
		</div>

		<!-- Historique -->

		<div *ngIf="!isCreation && showHistorique" class="field col-12">
			<label for="history">
				{{ 'common.history_label' | translate }}
			</label>
			<div>
				<historique-element-nomenclature [element]="rubrique"></historique-element-nomenclature>
			</div>
		</div>
	</div>

	<div class="text-center">
		<!-- Bouton éditer -->
		<button
			*ngIf="!editMode && canEdit"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.edition_button_label' | translate"
			icon="pi pi-pencil"
			(click)="toggleEditMode()"
		></button>

		<!-- Bouton enregistrer -->
		<button
			*ngIf="!!editMode"
			type="button"
			pButton
			class="label-md-none"
			[label]="'common.save_button_label' | translate"
			icon="pi pi-save"
			(click)="submit()"
			[disabled]="!rubriqueForm.valid"
		></button>
	</div>
</form>
